import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const getOBCodes = (companyId: any, svcCode: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_OB_CODES_REQUEST });

  return api.authorization.OBCodes.get(companyId, svcCode)
    .then((res: any) => {

      dispatch({
        type: types.GET_OB_CODES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_OB_CODES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
